import { render, staticRenderFns } from "./InfoMenu.vue?vue&type=template&id=61b314a8&scoped=true"
import script from "./InfoMenu.vue?vue&type=script&lang=js"
export * from "./InfoMenu.vue?vue&type=script&lang=js"
import style0 from "./InfoMenu.vue?vue&type=style&index=0&id=61b314a8&prod&scoped=true&lang=css"
import style1 from "./InfoMenu.vue?vue&type=style&index=1&id=61b314a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b314a8",
  null
  
)

export default component.exports